import { useEffect } from "react";
import {
  Switch,
  Route
} from "react-router-dom";

import LoginView from "../components/login/LoginView";
import HomeLayout from "../components/HomeLayout";
import { useQuery } from "../components/util/useQuery";
import { FORGOT_PASSWORD_URL, HOME_URL, RESET_PASSWORD_URL } from "../const/URL.const";
import ForgotPasswordView from "../components/login/ForgotPasswordView";
import { ResetPasswordView } from "../components/login/ResetPasswordView/ResetPasswordView";
// import { OAuthRedirector } from "../components/login/OAuthRedirector";

const HomeContainer = () => {
  const query = useQuery();
  useEffect(() => {
    if (query.get('isApp')) {
      sessionStorage.setItem('isApp', "true");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <HomeLayout>
      <Switch>
            <Route path={FORGOT_PASSWORD_URL} component={ForgotPasswordView} exact={true} />
            <Route path={RESET_PASSWORD_URL} component={ResetPasswordView} exact={true} />
            <Route path={HOME_URL} component={LoginView} exact={true} />
      </Switch>
    </HomeLayout>
  );
};

export default HomeContainer;
